import styles from './App.module.scss';
import { ThemeSelector } from './styles/themes/ThemeSelector';
import { ErrorPage, ErrorBoundary } from './components/error';
import { Layout } from './components/layout';
import { TranslateProvider, useTranslate } from './translations';
import { DataRequestForm, useDataRequest, getCurrentDataRequestId } from './features/data-request';
import { AnimatedLoading } from './components/spinner';
import { Alert } from './components/alert';

const Content = ({ error }: { error?: number | null }) => {
  const translator = useTranslate();

  if (error === 404) {
    return <Alert color="warning">{translator('alert_not_found')}</Alert>;
  }

  if (error) {
    return <Alert color="warning">{translator('alert_load_error')}</Alert>;
  }

  return <DataRequestForm />;
};

const DataRequestApp = () => {
  const { template, isLoading, error } = useDataRequest(getCurrentDataRequestId());

  if (isLoading) {
    return (
      <div style={{ width: '100%', height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <AnimatedLoading />
      </div>
    );
  }

  return (
    <TranslateProvider defaultLocale={'hu'}>
      <ThemeSelector theme={template}>
        <ErrorBoundary fallback={<ErrorPage />}>
          <Layout className={styles.layout}>
            <Content error={error} />
          </Layout>
        </ErrorBoundary>
      </ThemeSelector>
    </TranslateProvider>
  );
};

export default DataRequestApp;
